import * as moment from 'moment';

/**
 * Bookings confirmed with the patient, usually by a call before the day (tasks/appointment-confirmed.md).
 * The server stamps `confirmedAt` / `confirmedByName` and clears them when a booking moves or is cancelled.
 */

/** A patient booking still to happen that nobody has confirmed yet. Events are not bookings. */
export function needsConfirming(appointment: any): boolean {
  return !!appointment?.patientId &&
    !appointment.confirmedAt &&
    appointment.isCancelled !== true &&
    appointment.didNotAttend !== true &&
    !appointment.patientArrivedTime &&
    moment(appointment.date).isSameOrAfter(moment(), 'day');
}

/** A confirmation can be taken back until the patient arrives. */
export function canUnconfirm(appointment: any): boolean {
  return !!appointment?.confirmedAt && appointment.isCancelled !== true && !appointment.patientArrivedTime;
}

/** "Booking confirmed 12/10 08:30 by Ms Sam Naidoo", or '' when not confirmed. */
export function confirmationTooltip(appointment: any): string {
  if (!appointment?.confirmedAt) return '';
  const when = moment(appointment.confirmedAt).format('DD/MM HH:mm');
  return `Booking confirmed ${when}` + (appointment.confirmedByName ? ` by ${appointment.confirmedByName}` : '');
}

/** The body to save for a status-menu action: confirming asks the server to stamp it. */
export function statusUpdateBody(appointment: any, status: string): any {
  if (status === 'confirmed') return { ...appointment, confirmed: true };
  if (status === 'not_confirmed') return { ...appointment, confirmed: false };
  return appointment;
}
